import * as DataTableDAO from 'notebook/data-tables/DataTableDAO';
import notifications, {Response} from 'notifications';
import * as ImportUtil from 'util/ImportUtil';

import {BenchlingBlob} from './BlobConstants';

export function uploadFilesAsBlobs(
  files: Array<File>,
  {
    shouldGeneratePreviewFile,
    onBlobsCreated,
  }: {
    shouldGeneratePreviewFile: boolean;
    onBlobsCreated: (blobs: Array<BenchlingBlob>) => void;
  }
): JQueryPromise<void> {
  return ImportUtil.bulkUpload(files)
    .then((...s3Locations: Array<string>) =>
      DataTableDAO.createBlobs(s3Locations, {shouldGeneratePreviewFile})
    )
    .then((blobs: Array<BenchlingBlob>) => {
      onBlobsCreated(blobs);
    })
    .fail((e: Response) => {
      notifications.notifyError(e);
    });
}
